// ** React Imports
import { useState } from "react";

// ** Redux
import { useSelector } from "react-redux";

// ** Third Party Components
import { t } from "i18next";

// ** Custom Components
import Block from "components/layout/Block";
import AuthPanel from "containers/Landing/components/AuthPanel";
import Text from "components/typography/Text";

// ** Styled Components
import { StyledModalAuthContentWrapper } from "./styles/ModalAuthContentWrapper.styled";
import { StyledModalAuthMainSection } from "./styles/ModalAuthMainSection.styled";

// #####################################################

const ModalAuthContent = ({ innerRef }) => {
	const [activeTab, setActiveTab] = useState("login");

	const [googleAuth, setGoogleAuth] = useState({
		token: null,
		state: null,
		active: false,
	});

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);

	const authModalVersion = useSelector(
		(state) => state.globalCommon?.authModal?.version
	);

	// #####################################################

	return (
		<StyledModalAuthMainSection>
			<Block flex flexWrap fullWidth>
				<StyledModalAuthContentWrapper ref={innerRef}>
					<AuthPanel
						activeTab={activeTab}
						setActiveTab={setActiveTab}
						googleAuth={googleAuth}
						setGoogleAuth={setGoogleAuth}
						isModal={true}
						additionalContent={
							<Block flex flexWrap fullWidth py={6}>
								<Text>{t("common:authModal.infoText")}</Text>
							</Block>
						}
					/>
				</StyledModalAuthContentWrapper>
			</Block>
		</StyledModalAuthMainSection>
	);
};

// #####################################################

export default ModalAuthContent;

// #####################################################
